import type { ReactNode } from 'react';

import { cn } from '@repo/videa-components/src/lib/utils';

const OUTER_CLASSES =
  'vai-flex vai-flex-col vai-flex-1 vai-min-h-0 vai-w-full vai-overflow-hidden';

const HEADER_CLASSES = 'vai-flex-shrink-0 vai-w-full';

const BODY_CLASSES =
  'vai-flex-1 vai-min-h-0 vai-w-full vai-overflow-auto vai-px-2 vai-py-2';

const FOOTER_CLASSES =
  'vai-bottom-0 vai-z-10 vai-flex-shrink-0 vai-w-full vai-bg-background';

export interface SlideOutViewLayoutProps {
  /** Optional sticky header (flex-shrink-0). */
  header?: ReactNode;
  /** Scrollable body (flex-1 min-h-0 overflow-auto). */
  children: ReactNode;
  /** Optional sticky footer (flex-shrink-0). Use SheetFooter from @repo/videa-notes for action bars. */
  footer?: ReactNode;
  /** Extra class for the outer container. */
  className?: string;
  /** Extra class for the scrollable body area (default body has vai-px-2 vai-py-2). */
  bodyClassName?: string;
}

/**
 * Consistent layout for note slideout views: sticky header, scrollable body, sticky footer.
 * Use for AudioCapture, NoteResult, NoteError, NoteGeneration, and QuickNotePatientForm.
 */
export const SlideOutViewLayout = ({
  header,
  children,
  footer,
  className,
  bodyClassName,
}: SlideOutViewLayoutProps) => (
  <div className={cn(OUTER_CLASSES, className)}>
    {header != null && <div className={HEADER_CLASSES}>{header}</div>}
    <div className={cn(BODY_CLASSES, bodyClassName)}>{children}</div>
    {footer != null && <div className={FOOTER_CLASSES}>{footer}</div>}
  </div>
);
